module.exports = __webpack_public_path__ + "static/media/bell-sleeping-mode.ce86e1fa.svg";